import styled from "styled-components";
import { headerHeight, leftColumnWidth } from "../../constants";
import { StyledInputWrapperProps } from "./types";
import { RadioGroup, FormControlLabel } from "@mui/material";

export const StyledWrapper = styled.div`
  overflow: hidden;
  margin-top: 140px;
  width: ${leftColumnWidth + "px"};
  min-height: 100vh;
  position: sticky;
  left: 0;
  background-color: ${({ theme }) => theme.colors.background};
  box-shadow: 0px 4px 15px rgba(39, 55, 75, 0.16);
  z-index: 2;
`;

export const TextFilter = styled.p`
  color: #212121;
  @media (max-width: 800px) {
    display: none;
  }
`

export const StyledLeftColumnHeader = styled.div`
  padding-bottom: 4px;
  padding: 0 1rem;
  position: fixed;
  top: 89px;
  width: ${leftColumnWidth + "px"};
  height: calc(${({ theme }) => theme.navHeight} + ${headerHeight + "px"});
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  background-color: ${({ theme }) => theme.colors.background};
  z-index: 3;
  border-bottom: 1px solid rgb(224, 224, 224);
  box-shadow: rgba(39, 55, 75, 0.16) 4px -10px 15px;

  @media (max-width: 800px) {
    padding: 0 0.5rem;
    top: 74px
  }
`;

export const FormLabelStyled = styled.div`
  display: flex;
  align-items: center;
  font-weight: 700 !important;
  color: #781AA0;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 8px;

  > div {
    display: flex;
    cursor: pointer;

    button {
      &:hover {
        text-decoration: none;
      }
    }
  }

  button {
    background-color: transparent;
    border: 0;
    font-size: 1rem;
    color: #781AA0;
    cursor: pointer;
    font-weight: 400;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const RadioGroupStyled = styled(RadioGroup)`
  display: flex;
  gap: 1rem;

  @media (max-width: 800px) {
    justify-content: flex-start;
  }
`

export const FormControlLabelStyled = styled(FormControlLabel)`
  margin-right: 0 !important;
`

export const WrapperButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  @media (max-width: 800px) {
   margin-top: 10px;
  }
`

export const ButtonWithIcon = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(120, 26, 160) !important;
  border-radius: 100%;
  border: 0;
  cursor: pointer;
  margin-right: 4px;
`

export const Button = styled.button`
  all: unset;
  line-height: 0 !important;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 2px;
  
  &:hover {
    border-color: #E0E0E0;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.1);

    svg path {
      fill: #781AA0;
    }
  }
`

export const ButtonAgroup = styled(Button)<{isActive: "agroup" | "search" | null}>`
border-color: ${({ isActive }) => ( isActive === 'agroup' ?  '#E0E0E0': '0')};
box-shadow: ${({ isActive }) => ( isActive === 'agroup' ?  '0 2px 8px 0 rgba(0,0,0,0.1)': 'none')};

  svg path {
      fill: ${({ isActive }) => ( isActive === 'agroup' ?  '#781AA0': '#616161')} ;
    }
 
`

export const ButtonSearch = styled(Button)<{isActive: "agroup" | "search" | null}>`
border-color: ${({ isActive }) => ( isActive === 'search' ?  '#E0E0E0': '0')};
box-shadow: ${({ isActive }) => ( isActive === 'search' ?  '0 2px 8px 0 rgba(0,0,0,0.1)': 'none')};

  svg path {
      fill: ${({ isActive }) => ( isActive === 'search' ?  '#781AA0': '#616161')} ;
    }
 `

export const StyledInput = styled.input`
  height: 100%;
  width: calc(100% - 44px);
  background-color: transparent;
  color: ${({ theme }) => theme.colors.textPrimary};
  padding: 7px 0 7px 12px;
  border: 0;
  outline: none;
  &::placeholder {
    color: ${({ theme }) => theme.colors.placeholder};
  }
`;

export const StyledInputWrapper = styled.div<StyledInputWrapperProps>`
  margin-left: 10px;
  height: 36px;
  width: calc(100% - 20px); //20px = 10px margin each side
  background-color: ${({ theme }) => theme.colors.primary};
  border: 1px solid
    ${({ theme, isFocused }) => (isFocused ? theme.colors.accent : theme.colors.border)};
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    margin-left: auto;
    margin-right: 12px;
    height: 24px;
    width: 24px;
  }
`;
